import React, { useCallback, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import SweetAlert from "react-bootstrap-sweetalert";
import { useNavigate } from "react-router-dom";


const ModalMensagem = ({
}) => {
  const [show,setShowModal]=useState(false);
  const navigate = useNavigate();
  const checkPontuacao = (pontos)=>{
    if(pontos>=100) return 'Atendimento total';
    if(pontos>=75 && pontos <100) return 'Atendimento parcial';
    if(pontos>=50 && pontos <75) return 'Atendimento moderado';
    if(pontos>=25 && pontos <50) return 'Atendimento básico';
    if(pontos>=1 && pontos <25) return 'Atendimento falho';
    if(pontos<1) return 'Atendimento inexistente';
  }

  useEffect(()=>{
    setShowModal(true);
  },[]);
 
  return (
    <>
      <SweetAlert
        title="Aviso"
        warning
        show={show}
        confirmBtnText="Ir para a página"
        onConfirm={()=>{
          navigate('/usabilidade/avaliacao/visibilidade');
        }}
      >
        Como estamos fora do perído de avaliação, para testar o processo vá para a página "Visibilidade do status do sistema"
      </SweetAlert>
    </>
  );
};

export default ModalMensagem;
